import {
    Button,
} from 'appkit-react';

import ConfigurationTable from './ConfigurationTable';

const ConfigurationTab = ({
    selectedNode, onFilterChange, onOperationChange, error, label, selectedColumns,
    handleClick, getAppendComponent, selectedType, getJoinComponent,
    getAggregateReconComponent,
}) => {
    const getInputComponent = () => (
        <>
            <div className="true-comply-datarecon__tabs-tabone-header">
                <p>{`File Name : ${label}`}</p>
                <div className="true-comply-datarecon__tabs-tabone-header__icons-section">
                    <Button size="sm" kind="secondary" onClick={handleClick}>SELECT COLUMNS</Button>
                    <span className="appkiticon icon-transform-outline" />
                    <span className="appkiticon icon-delete-fill" />
                </div>
            </div>
            {selectedColumns?.selectedColumns && (
                <div className="true-comply-datarecon__tabs-tabone-body marginTop20">
                    <ConfigurationTable
                        onFilterSave={onFilterChange}
                        selectedColumns={selectedColumns}
                        onOperationSave={onOperationChange}
                    />
                </div>
            )}
        </>
    );

    const getReconFunctionComponent = () => {
        let component;
        switch (label) {
            case 'Append':
                component = getAppendComponent();
                break;
            case 'Join':
                component = getJoinComponent();
                break;
            case 'Sum':
            case 'Min':
            case 'Max':
                component = getAggregateReconComponent();
                break;
            default:
                component = <div />;
                break;
        }
        return component;
    };

    if (error) {
        return (
            <div
                className="a-h6"
                style={{
                    backgroundColor: '#f8d7da', color: '#721c24', padding: '0.5rem 0.5rem', borderRadius: '3px', width: '100%', textAlign: 'center', borderColor: '#f5c6cb',
                }}
            >
                {error.message}
            </div>
        );
    }
    if (selectedType === 'input') {
        return getInputComponent();
    }
    if (label && Object.keys(selectedNode).length > 0) {
        return getReconFunctionComponent();
    }
    return <div />;
};

export default ConfigurationTab;
